import { render, staticRenderFns } from "./UseData.vue?vue&type=template&id=4ee18f18&scoped=true&"
import script from "./UseData.vue?vue&type=script&lang=js&"
export * from "./UseData.vue?vue&type=script&lang=js&"
import style0 from "./UseData.vue?vue&type=style&index=0&id=4ee18f18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee18f18",
  null
  
)

export default component.exports